import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React from "react";
import { CheckoutProvider } from "./hooks/CheckoutContext";

const queryClient = new QueryClient();

const WrapWithProvider = ({ element }) => {
  return (
    <QueryClientProvider client={queryClient}>
      <CheckoutProvider>{element}</CheckoutProvider>
    </QueryClientProvider>
  );
};

export default WrapWithProvider;
